__turbopack_context__.v({
  "review": "styles-module__Mc_vuq__review",
});
